import React from 'react';
import { getQueryStringVal } from 'helper/QueryString';
import User from 'helper/currentUser';
import { LoginRoot } from './styles';

const loginPagesHashes = ['/login', '/login-redirect'];

const urlIsOfLoginPages = hash => {
  let includes = false;
  const urlPath = hash.slice(1).split('?')[0];
  loginPagesHashes.forEach(path => {
    if (urlPath === path) {
      includes = true;
    }
  });
  return includes;
};

const LoginWrapper = ({ children, className = '' }) => {
  const user = new User();
  const tempFMOLogin = !!window.localStorage.getItem('user_fmo_temp_login');

  if (
    urlIsOfLoginPages(window.location.hash) &&
    user.aToken() &&
    user.id() &&
    user.companyId() &&
    !tempFMOLogin
  ) {
    const redirectQS = getQueryStringVal('redirect', window.location.href);
    if (redirectQS) {
      window.location.href = redirectQS;
    } else {
      window.location.href = '/#/learner';
    }
    return true;
  }
  return <LoginRoot className={className}>{children}</LoginRoot>;
};

export default LoginWrapper;
